<template>
	<v-app id="inspire">
		<!-- Top Navigation Bar -->
		<user-nav-menu bg-color="#F6F6F6" :logo-file-name="tenant.settings.brandImages.headerLogos.app.dark"></user-nav-menu>

		<v-main>
			<v-container class fluid>
				<router-view />
				<!--slot / -->
			</v-container>
		</v-main>

		<request-form ref="RequestForm"></request-form>

		<v-footer app>
			<span>&copy; {{ new Date().getFullYear() }}</span>
		</v-footer>
	</v-app>
</template>

<script>
import UserNavMenu from '@/components/user/UserNavMenu';
import store from '@/store';
import axios from 'axios';
import moment from 'moment';
import { bus } from '@/main';
import RequestForm from '@/components/custom/RequestForm.vue';

export default {
	name: 'PracticeDashboardLayout',
	components: {
		UserNavMenu,
		RequestForm,
	},
	computed: {
		user: () => store.getters.user,
		company: () => store.getters.company,
	},
	mounted() {
		// accept event from user menu comp to update the drawer value
		bus.$on('setDrawer', () => (this.drawer = !this.drawer));

		bus.$on('show-request-form', () => {
			this.$refs.RequestForm.open();
		});

		bus.$on('dismiss-request-form', () => {
			this.$refs.RequestForm.close();
		});
	},
	methods: {
		queryAllPractices() {
			const token = store.getters.jwtToken; //get the token from store
			axios.get(store.getters.getAPI + '/companies', { headers: { Authorization: token } }).then(response => {
				let results = [];
				const headers = [
					'practice_ID',
					'name',
					'landline',
					'bussiness_email',
					'Email Contact Person First Name',
					'Surname',
					'User Cell Nr',
					'City',
					'Province',
					'created on',
				];

				response.data.data.Items.forEach(practice => {
					practice.managers.forEach(manager => {
						let output = {
							practice_ID: practice.id,
							name: practice.name,
							landline: practice.contact,
							bussiness_email: practice.email,
							'Email Contact Person First Name': manager.name,
							Surname: manager.surname,
							'User Cell Nr': manager.contact,
							City: practice.address.region,
							Province: practice.address.province,
							'created on': moment(practice.createdAt).format('DD/MM/YYYY'),
						};
						results.push(output);
					});
				});

				let csvString = '';

				csvString += headers.join(',') + '\n';
				let rows = results.map(row => Object.values(row).join(','));
				csvString += rows.join('\n');
				console.info('[dirty] Final output :\n', csvString);
			});
		},
	},
};
</script>
